export enum Role {
  // Firm Admin
  FAdmin = 'fadmin',
  // Thomson Reuters Admin
  TAdmin = 'tadmin',
  // Extract Admin
  EAdmin = 'eadmin',
  // General User
  GUser = 'guser',
  // No access User this user cannot access FI Features
  NOAccess = 'noaccess',
}

export enum DateFormat {
  mmddyyyy = 'mm-dd-yyyy',
  yyyymmdd = 'yyyy-mm-dd',
  mmddpostfixyyyy = 'mm-dd-postfix-yyyy',
  mmddyyyyWithSlash = 'MM/dd/yyyy',
  MMMMy = 'MMMM y',
}
export enum featureToggle {
  'export-summary' = 'EXPORT_SUMMARY',
}

export enum GeographicRollupLevel {
  OFFICE = 'OFFICE',
  CITY = 'CITY',
  REGION = 'REGION',
  COUNTRY = 'COUNTRY',
}

/*Cleanup of unwanted colors pending*/
export enum trBrandingColors {
  colorTrOrange1 = ' #561a00',
  colorTrOrange2 = ' #802600',
  colorTrOrange3 = ' #ab3300',
  colorTrOrange = ' #d64000',
  colorTrOrange4 = ' #de6633',
  colorTrOrange5 = ' #e68c66',
  colorTrOrange6 = ' #efb399',
  /* TR Racing Green */
  colorTrRacingGreen = ' #123015',
  colorTrRacingGreen1 = ' #314b3e',
  colorTrRacingGreen2 = ' #50665b',
  colorTrRacingGreen3 = ' #6e8178',
  colorTrRacingGreen4 = ' #8d9c94',
  colorTrRacingGreen5 = ' #acb7b1',
  colorTrRacingGreen6 = ' #cbd1ce',
  /* TR Dark Sky */
  colorTrDarkSky1 = ' #032e5b',
  colorTrDarkSky2 = ' #054688',
  colorTrDarkSky3 = ' #065db6',
  colorTrDarkSky = ' #0874e3',
  /* TR Light Sky */
  colorTrLightSky2 = ' #3990e9',
  colorTrLightSky1 = ' #6bacee',
  colorBackgroundTrLightSky = ' #e3f1fd',
  /* TR Dark Teal */
  colorTrDarkTeal1 = ' #1f473d',
  colorTrDarkTeal2 = ' #2e6b5c',
  colorTrDarkTeal3 = ' #3e8e7a',
  colorTrDarkTeal = ' #4db299',
  /* TR Light Teal */
  colorTrLightTeal2 = ' #71c1ad',
  colorTrLightTeal1 = ' #94d1c2',
  colorBackgroundTrLightTeal = ' #e3f3ee',
  /* TR Dark Lime */
  colorTrDarkLime1 = ' #395128',
  colorTrDarkLime2 = ' #567a3c',
  colorTrDarkLime3 = ' #72a250',
  colorTrDarkLime = ' #8fcb64',
  /* TR Light Lime */
  colorTrLightLime2 = ' #a5d583',
  colorTrLightLime1 = ' #bce0a2',
  colorBackgroundTrLightLime = ' #e1f4cd',
  /* TR Dark Gold */
  colorTrDarkGold1 = ' #5d461c',
  colorTrDarkGold2 = ' #8c6a29',
  colorTrDarkGold3 = ' #ba8d37',
  colorTrDarkGold = ' #e9b045',
  /* TR Light Gold */
  colorTrLightGold2 = ' #edc06a',
  colorTrLightGold1 = ' #f2d08f',
  colorBackgroundTrLightGold = ' #fcf2da',
  /* TR Dark Amber */
  colorTrDarkAmber1 = ' #553011',
  colorTrDarkAmber2 = ' #7f4919',
  colorTrDarkAmber3 = ' #aa6122',
  colorTrDarkAmber = ' #d4792a',
  /* TR Light Amber */
  colorTrLightAmber2 = ' #dd9455',
  colorTrLightAmber1 = ' #e5af7f',
  colorBackgroundTrLightAmber = ' #f8eadd',
  /*Other colors*/
  colorTrBlack = '#000000',
  colorTrGraphite = '#212223',
  colorTrGrey1 = '#e5e5e5',
  colorTrGrey2 = '#9f9f9f',
  colorTrGrey3 = '#7a7a7a',
}
